import { createAsync } from "@solidjs/router";
import { getAssessmentStatus } from "~/lib";

enum AssessmentStatusEnum {
	PASSED = "passed",
	FAILING = "failing",
	EXPIRED = "expired",
	NOT_ATTEMPTED = "not-attempted",
	PROGRESSING = "progressing",
}

export const AssessmentStatus = ( props: { userId: number, moduleKey: string } ) => {

	const assessmentStatus = createAsync( async () => await getAssessmentStatus( props.userId ) );

	let status = (): AssessmentStatusEnum | undefined => {
		if ( assessmentStatus() ) {

			const mod = assessmentStatus()?.[props.moduleKey];

			if ( mod ) {

				if ( mod?.recent == 6 ) {
					return AssessmentStatusEnum.PASSED;
				} else if ( mod?.total == 6 ) {
					return AssessmentStatusEnum.EXPIRED;
				} else if ( mod?.attempted < 2 ) {
					return AssessmentStatusEnum.NOT_ATTEMPTED;
				} else if ( mod?.attempted - mod?.total >= 3 ) {
					return AssessmentStatusEnum.FAILING;
				} else if ( mod?.attempted - mod?.total < 3 ) {
					return AssessmentStatusEnum.PROGRESSING;
				} else {
					return AssessmentStatusEnum.NOT_ATTEMPTED;
				}
			}
		}

		return;
	}

	return (
		<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-[11.5px] font-medium capitalize"
			classList={{
				"bg-green-200 text-green-700": status() == AssessmentStatusEnum.PASSED,
				"bg-yellow-200 text-yellow-700": status() == AssessmentStatusEnum.EXPIRED || status() == AssessmentStatusEnum.PROGRESSING,
				"bg-red-200 text-red-700": status() == AssessmentStatusEnum.FAILING,
				"bg-gray-200 text-gray-700": status() == AssessmentStatusEnum.NOT_ATTEMPTED,
			}}>{status()}</span>
	);
}